/**
 * 关闭手机菜单：先加 menu_closing 再移除 menu_open，侧栏 transform 结束后再清 menu_closing，
 * 使顶栏/蒙层层级在关菜单动画期间仍生效。
 */
(function () {
    function unifyCloseMobileMenu() {
        var body = document.body;
        if (!body.classList.contains('menu_open')) {
            if (body.classList.contains('menu_closing')) {
                return;
            }
            body.classList.remove('menu_closing');
            return;
        }
        body.classList.add('menu_closing');
        body.classList.remove('menu_open');
        var nav = document.getElementById('navigation-mobile');
        var cleaned = false;
        function cleanup() {
            if (cleaned) {
                return;
            }
            cleaned = true;
            body.classList.remove('menu_closing');
            if (nav) {
                nav.removeEventListener('transitionend', onEnd);
            }
            document.querySelectorAll('[data-mobile-menu]').forEach(function (btn) {
                btn.setAttribute('aria-expanded', 'false');
            });
        }
        function onEnd(e) {
            if (e.target === nav && e.propertyName === 'transform') {
                cleanup();
            }
        }
        if (nav) {
            nav.addEventListener('transitionend', onEnd);
        }
        setTimeout(cleanup, 800);
    }
    window.unifyCloseMobileMenu = unifyCloseMobileMenu;
})();

function menuSidebarMobile() {
    if (typeof window.mobile_menu === 'undefined') {
        window.mobile_menu = 'default';
    }

    const $body = $('body');
    const $header = $('.header');
    const $navigationMobile = $('#navigation-mobile');
    const $headerTopWrapper = $('.header-top--wrapper .header-top--right');
    const $mobileNavAccount = $navigationMobile.find('.site-nav-mobile.nav-account .wrapper-links');

    function moveElementIfNotExists(selector, target, insertMethod = 'appendTo') {
        const $element = $(selector);
        if (!$element.length) return;
        
        if (insertMethod === 'insertBefore') {
            $element.insertBefore(target);
        } else {
            $element.appendTo(target);
        }
    }

    $(document).on('click', '.mobileMenu-toggle', function(event) {
        event.preventDefault();
        $body.addClass('menu_open');

        if (window.mobile_menu === 'default' && !$navigationMobile.find('.site-nav-mobile.nav .header__inline-menu').length) {
            $('.header .header__inline-menu').appendTo($navigationMobile.find('.site-nav-mobile.nav'));
        }

        const elementsToMove = [
            { selector: '.free-shipping-text', target: $mobileNavAccount },
            { selector: '.customer-service-text', target: $mobileNavAccount },
            { selector: '.header__location', target: $mobileNavAccount }
        ];

        elementsToMove.forEach(item => {
            moveElementIfNotExists($headerTopWrapper.find(item.selector), item.target);
        });

        if (!$navigationMobile.find('.top-language-currency').length) {
            const currencySelector = $header.hasClass('header-03') ? '.header-bottom-right' :
                                   $header.hasClass('header-05') ? '.header-top--left' :
                                   '.header-language_currency';
            
            const $currencyElement = $(`.header ${currencySelector} .top-language-currency`);
            if ($currencyElement.length) {
                $currencyElement.appendTo($navigationMobile.find('.site-nav-mobile.nav-currency-language'));
            }
        }
    });

    function handleMenuClose() {
        if (window.unifyCloseMobileMenu) {
            window.unifyCloseMobileMenu();
        } else {
            $body.removeClass('menu_open');
        }
        $navigationMobile.off('transitionend.toggleCloseMenu').on('transitionend.toggleCloseMenu', () => {
            if ($body.hasClass('menu_open')) return;

            const $inlineMenu = $navigationMobile.find('.site-nav-mobile.nav .header__inline-menu');
            if ($inlineMenu.length) {
                const targetSelector = $header.is('.header-03, .header-04, .header-07, .header-08') ?
                    '.header .header-bottom--wrapper .header-bottom-left' :
                    '.header .header-bottom--wrapper';
                $inlineMenu.appendTo(targetSelector);
            }

            if (!$('.header-04').hasClass('style_2')) {
                moveElementIfNotExists($mobileNavAccount.find('.free-shipping-text'),
                    '.header-top--wrapper .header-top--right .header__group', 'insertBefore');
            }

            moveElementIfNotExists($mobileNavAccount.find('.header__location'),
                '.header-top--wrapper .header-top--right .header__group', 'insertBefore');

            const $customerService = $mobileNavAccount.find('.customer-service-text');
            if ($customerService.length) {
                const target = $header.hasClass('header-03') ?
                    '.header-top--wrapper .header-top--right .header__group .header__icon--wishlist' :
                    '.header-top--wrapper .header-top--right .top-language-currency';
                $customerService.insertBefore(target);
            }

            const $currencyMenu = $navigationMobile.find('.site-nav-mobile .top-language-currency');
            if ($currencyMenu.length) {
                const targetSelector = $header.hasClass('header-03') || $header.hasClass('header-04') ?
                    '.header .header-bottom--wrapper .header-bottom-right .header-language_currency' :
                    $header.hasClass('header-05') ?
                    '.header .header-top--wrapper .header-top--left .header-language_currency' :
                    '.header .header-language_currency .header__search';
                
                if (!$header.hasClass('header-05') && !$header.hasClass('header-03') && !$header.hasClass('header-04')) {
                    $currencyMenu.insertBefore(targetSelector);
                } else {
                    $currencyMenu.appendTo(targetSelector);
                }
            }
        });
    }

    $(document).on('click', '.halo-sidebar-close, .background-overlay', handleMenuClose);

    $(document).on('click', '.halo-sidebar-close', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (window.unifyCloseMobileMenu) {
            window.unifyCloseMobileMenu();
        } else {
            $body.removeClass('menu_open');
        }
    });
}

document.addEventListener('DOMContentLoaded', function() {
    menuSidebarMobile();
});